import { Breakpoints, breakpoints } from './breakpoints';
import { Palette, lightThemePalette, darkThemePalette } from './palette';
import { Shape, shape } from './shape';
import { Sizing, sizing } from './sizing';
import { Spacing, spacing } from './spacing';
import { typography, Typography } from './typography';

export interface Theme {
  palette: Palette;
  spacing: Spacing;
  shape: Shape;
  typography: Typography;
  breakpoints: Breakpoints;
  sizing: Sizing;
}

export const theme: Theme = {
  palette: lightThemePalette,
  spacing,
  shape,
  typography,
  breakpoints,
  sizing,
};

export const themes = {
  lightThemePalette,
  darkThemePalette,
};
